import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useTranslation } from 'react-i18next';
import type { SisuActionKey } from '../SisuActionPopover/actionKey';
import s from './TooltipSisuContent.scss';

interface Props {
  actionKey: SisuActionKey;
  onJoinClick: () => void;
}

const TooltipSisuContent: React.FC<Props> = ({ actionKey, onJoinClick }) => {
  const { t } = useTranslation();
  const titleKey = `sisu.action_popover.title.${actionKey}`;
  const bodyKey = `sisu.action_popover.body.${actionKey}`;
  const ctaKey = `sisu.action_popover.cta.${actionKey}`;

  return (
    <div className={s['root']}>
      <div className={s['title']}>
        {t(titleKey, { defaultValue: t('sisu.action_popover.title.default') })}
      </div>
      <div className={s['body']}>
        {t(bodyKey, { defaultValue: t('sisu.action_popover.body.default') })}
      </div>
      <PlainButtonOrLink className={s['cta']} onClick={onJoinClick}>
        {t(ctaKey, { defaultValue: t('sisu.action_popover.cta.default') })}
      </PlainButtonOrLink>
    </div>
  );
};

TooltipSisuContent.displayName = 'TooltipSisuContent';

export default TooltipSisuContent;
